const binding = { modules: {}, dataActions: {} };

    (binding.modules['social-link-container'] = {
        c: () => require('partner/modules/social-link-container/social-link-container.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'social-link-container',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/social-link-container'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|social-link-container|social-link-container'] = {
                c: () => require('partner/modules/social-link-container/social-link-container.view.tsx'),
                cn: '__local__-__local__-social-link-container'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };